import React, { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAlert, useApi } from "@/";
import { Button, InputField } from "@/components";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get("token");
  const email = searchParams.get("email");
  const { alert, AlertDialog } = useAlert();
  const { callApi, loading } = useApi();

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: email || "",
    newPassword: "",
    confirmPassword: "",
    resetToken: resetToken || "",
  });

  const [errors, setErrors] = useState({
    email: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user starts typing
    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    if (!formData.newPassword) {
      newErrors.newPassword = "New password is required";
      isValid = false;
    } else if (formData.newPassword.length < 8) {
      newErrors.newPassword = "Password must be at least 8 characters";
      isValid = false;
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
      isValid = false;
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrors(newErrors);
    console.log(isValid);
    return isValid;
  };
  console.log(formData);
  console.log("validateform", validateForm);

  const handleResetPassword = async () => {
    if (!validateForm()) return;

    try {
      const response = await callApi("/common/reset-password", "POST", {
        email: formData.email,
        newPassword: formData.newPassword,
        confirmPassword: formData.confirmPassword,
        token: formData.resetToken,
      });

      if (response.success) {
        await alert(
          "Password reset successful! Please login with your new password."
        );
        navigate("/login");
      } else {
        await alert(
          response.message || "Failed to reset password. Please try again."
        );
      }
    } catch (error) {
      await alert(
        error.message || "An unexpected error occurred. Please try again later."
      );
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background_2 to-background p-6">
      <div className="flex flex-col gap-4 w-full md:w-1/2  p-6 bg-background_2 rounded-lg shadow-md">
        <h2 className="text-handline4 sm:text-headline3 font-nunito font-bold text-center mb-4">
          Reset Password
        </h2>
        <InputField
          label="New Password"
          type="password"
          placeholder="Enter new password"
          value={formData.newPassword}
          onChange={(value) => handleChange("newPassword", value)}
          error={errors.newPassword}
          disabled={loading}
        />

        <InputField
          label="Confirm Password"
          type="password"
          placeholder="Confirm new password"
          value={formData.confirmPassword}
          onChange={(value) => handleChange("confirmPassword", value)}
          error={errors.confirmPassword}
          disabled={loading}
        />

        <Button
          className="h-12 w-full mt-4"
          size="md"
          onClick={handleResetPassword}
          isLoading={loading}
        >
          Reset Password
        </Button>

        <p className="text-sm text-center text-primary/80 hover:underline">
          Remember your password?{" "}
          <span onClick={() => navigate("/login")}>Login here</span>
        </p>
      </div>
      <AlertDialog />
    </div>
  );
};

export default ResetPassword;
